if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Validate addons: if toggle is on, select must have a value
        const addonsSection = document.querySelector('.product-custom-addons-wrapper');
        if (addonsSection) {
          addonsSection.querySelectorAll('.addon-select-product').forEach((s) => s.classList.remove('addon-select-product--error'));
          const invalidTitles = [];
          for (const addonBlock of addonsSection.querySelectorAll('.product-card-addon')) {
            const toggle = addonBlock.querySelector('.toggle-switch');
            const select = addonBlock.querySelector('.addon-select-product');
            if (toggle && !toggle.disabled && toggle.checked && select && !select.value.trim()) {
              select.classList.add('addon-select-product--error');
              const title = select.getAttribute('data-product-title');
              if (title) invalidTitles.push(title);
            }
          }
          if (invalidTitles.length > 0) {
            const message = invalidTitles.length === 1
              ? `Please choose an option for "${invalidTitles[0]}".`
              : `Please choose an option for: ${invalidTitles.map((t) => `"${t}"`).join(' and ')}.`;
            this.handleErrorMessage(message);
            return;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Collect all items to add (main product + personalised products)
        const itemsToAdd = this.collectItemsToAdd();

        // Add all items to cart
        this.addItemsToCart(itemsToAdd, evt);
      }

      collectItemsToAdd() {
        const items = [];
        const formData = new FormData(this.form);
        const mainProductId = formData.get('id');
        const mainProductQuantity = parseInt(formData.get('quantity')) || 1;

        // Get personalisation name if entered
        const nameInput = document.getElementById('personalised-name-plate-text');
        const personalisedName = nameInput ? nameInput.value.trim() : '';

        // ✅ Generate unique bundle ID for linking all items together
        const bundleId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        
        // Check if there are any addons being added
        let hasAddons = false;
        
        // Check for name plate addon
        if (personalisedName && nameInput && nameInput.getAttribute('data-variant-id')) {
          hasAddons = true;
        }
        
        // Check for other addons
        const addonsSection = document.querySelector('.product-custom-addons-wrapper');
        if (addonsSection) {
          addonsSection.querySelectorAll('.product-card-addon').forEach((addonBlock) => {
            const toggle = addonBlock.querySelector('.toggle-switch');
            const select = addonBlock.querySelector('.addon-select-product');
            if (toggle && !toggle.disabled && toggle.checked && select && select.value) {
              hasAddons = true;
            }
          });
        }

        // Add main product
        const mainItem = {
          id: mainProductId,
          quantity: mainProductQuantity,
          properties: {
            '_sh_bundle_id': bundleId
          }
        };

        // Add personalisation to main product if name is provided
        if (personalisedName) {
          mainItem.properties['Personalised Name'] = personalisedName;
        }
        
        // ✅ Add bundle ID if there are addons (to link items together)
        if (hasAddons) {
          mainItem.properties['_sh_bundle_id'] = bundleId;
        }

        items.push(mainItem);

        // Add product_3 (name plate) x2 if name input has value
        if (personalisedName && nameInput) {
          const variantId = nameInput.getAttribute('data-variant-id');
          const varientQty = nameInput.getAttribute('data-qty');
          if (variantId) {
            items.push({
              id: variantId,
              quantity: varientQty,
              properties: {
                'Personalised Name': personalisedName,
                '_sh_bundle_id': bundleId  // ✅ Link to bundle
              }
            });
          }
        }

        // Loop through all addon blocks
        if (addonsSection) {
          addonsSection.querySelectorAll('.product-card-addon').forEach((addonBlock) => {
            const toggle = addonBlock.querySelector('.toggle-switch');
            const select = addonBlock.querySelector('.addon-select-product');

            if (toggle && !toggle.disabled && toggle.checked && select && select.value) {
              const dataAddon = select.getAttribute('data-addon');
              const addonItem = {
                id: select.value,
                quantity: 1,
                properties: {
                  '_sh_bundle_id': bundleId  // ✅ Link to bundle
                }   
              };
              items.push(addonItem);
              if (personalisedName && nameInput && dataAddon > 0) {
                const addonItem2 = {
                  id: dataAddon,
                  quantity: 1,
                  properties: {
                    '_sh_bundle_id': bundleId  // ✅ Link to bundle
                  }   
                };
                items.push(addonItem2);
              }
            }
          });
        }

        return items;
      }

      formatPrice(priceInCents) {
        return `$${(priceInCents / 100).toFixed(2)}`;
      }

      addItemsToCart(items, evt) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const sectionsToRender = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        const body = {
          items: items,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        };

        config.body = JSON.stringify(body);

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: items[0].id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: items[0].id,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            
            // ✅ Trigger sync after cart update (standardized timeout)
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }, 300);
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('An error occurred. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}